module.exports = __webpack_public_path__ + "static/media/plusIconblue.a2006dd7.svg";